import { Component, OnInit, Input, OnDestroy, EventEmitter, Output, ViewChild, AfterViewInit } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { NewTripComponent } from '../../component/assigned-trips/new-trip/new-trip.component';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import { Events } from 'src/app/utils/event-utils';
import { SocketService } from 'src/app/service/socket-service/socket-service.service';
import { sweetAlert, sweetAlertWithInput } from 'src/app/utils/swal';
import { DriversService } from '../../component/drivers/drivers-service/drivers-service';
import { LevelOfServiceService } from '../../component/level-of-service/service/level-of-service.service';
import { forkJoin } from 'rxjs';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import * as moment from 'moment';
import { MenuService } from 'src/app/component/shared/layout/menu-service/menu.service';
import { hasOvertimeViolation } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-edit-trip-modal',
  templateUrl: './edit-trip-modal.component.html',
  styleUrls: ['./edit-trip-modal.component.css']
})
export class EditTripModalComponent implements OnInit,AfterViewInit, OnDestroy {
  @ViewChild('tripComponent', { static: false }) tripComponent: NewTripComponent;
  @ViewChild(GoogleMap, { static: false }) googleMap: GoogleMap;
  @Input() tripId: any;
  @Input() trip?: any;
  @Input() agentTrip?: any;
  @Input() source?: any;
  @Input() scheduleTime?:any
  @Input() driverId?:any
  @Input() isStandingOrderClone?: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onUpdate = new EventEmitter<string>();
  @Output() onCreate = new EventEmitter<string>();

   renderOptions = {
    suppressMarkers: true,
      // polylineOptions: {
      //   strokeColor: '#FF5733', // Set the desired color for the path
      //   strokeOpacity: 1,       // Set the opacity (0 to 1)
      //   strokeWeight: 4,       // Set the desired width of the path
      // },
  };

  directions = {
    origin : { lat: 0.00000, lng: 0.00000 },
    destination : { lat: 0.00000, lng: 0.00000 }
  }
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  driverLoc = { lat: 0.00000, lng: 0.00000 };

  isShowCancel = false;
  drivers = [];
  driverIndex = -1;
  selectedDriver;
  searchDriver = '';
  preLevelOfServices = {};
  preSpaceTypes:any = {};
  isAllowRoute = false;
  user;
  timeZone;
  userRole;

  constructor(private assignTripService: AssigTripsService, private menuService: MenuService,
    private socketService: SocketService, private driverService: DriversService,   private levelOfServiceService : LevelOfServiceService, private sharedDataService : SharedDataService) { }


  ngOnInit() {

    this.listenSocket();
    if (this.trip) {
      this.origin = {
        lat: this.trip.jobOriginLatitude,
        lng: this.trip.jobOriginLongitude
      };

      this.destination = {
        lat: this.trip.jobDestinationLatitude,
        lng: this.trip.jobDestinationLongitude
      };

      this.directions.origin = this.origin;
      this.directions.destination = this.destination;

      // if (this.trip.driver) {
      //   if (typeof this.trip.driver === 'string') {
      //     this.selectedDriver = this.trip.driver;
      //   } else {
      //     this.selectedDriver = this.trip.driver;
      //   }
      // }
    }
    this.getUser();
  }
  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.user = data
          this.timeZone = data.timeZone;
          this.makeCompulsoryCalls();

          if (this.user && this.user.roles) {
            if ((typeof this.user.roles) === 'string') {
              if(this.user.sRoles) {
                this.userRole = this.menuService.getUserRoleTitle(this.user.sRoles);
              } else {
                this.userRole = this.menuService.getUserRoleTitle(this.user.roles);
              }
            } else if ((typeof this.user.roles) === 'object') {
              this.userRole = this.menuService.getUserRoleTitle(this.user.roles[0]);
            }
          }

        }
      });
  }


  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypes()
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2]) => {
        if (res1) {
          this.preLevelOfServices = res1.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (res2) {
          this.preSpaceTypes = res2.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
        if (this.trip) {
          this.getNearbyDriver();
        }
        if(this.scheduleTime){
          this.getDriverList();
        }
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  ngAfterViewInit(): void {

    this.tripComponent.newTripForm.controls['jobOriginLatitude'].valueChanges.pipe(takeUntil(takeUntilDestroyed(this))).subscribe(
      (lat) => {
          this.origin.lat = lat;
          this.updateBounds();
      }
    );

    this.tripComponent.newTripForm.controls['jobOriginLongitude'].valueChanges.pipe(takeUntil(takeUntilDestroyed(this))).subscribe(
      (lng) => {
        this.origin.lng = lng;
        this.updateBounds();
      }
    );


    this.tripComponent.newTripForm.controls['jobDestinationLatitude'].valueChanges.pipe(takeUntil(takeUntilDestroyed(this))).subscribe(
      (lat) => {
          this.destination.lat = lat;
          this.updateBounds();
      }
    );

    this.tripComponent.newTripForm.controls['jobDestinationLongitude'].valueChanges.pipe(takeUntil(takeUntilDestroyed(this))).subscribe(
      (lng) => {
        this.destination.lng = lng;
        this.updateBounds();
      }
    );

  }

  onMapReady(map: google.maps.Map) {
    this.updateBounds();
  }

  updateBounds() {
    if (!this.googleMap) return;
    const bounds = new google.maps.LatLngBounds();
    if (this.origin.lat && this.origin.lng) bounds.extend(this.origin);
    if (this.destination.lat && this.destination.lng) bounds.extend(this.destination);
    if (this.driverLoc.lat && this.driverLoc.lng) bounds.extend(this.driverLoc);
    if (this.selectedDriver && this.selectedDriver.startingPointAddress) {
      bounds.extend({
        lat: this.selectedDriver.startingPointAddress.latitude,
        lng: this.selectedDriver.startingPointAddress.longitude
      });
    }
    if (!bounds.isEmpty()) {
      this.googleMap.fitBounds(bounds);
    }
  }

  getLevelOfService() {
    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypes() {
  return this.levelOfServiceService.getSpaceTypes({ status: 'active' });

  }

  listenSocket() {
    this.socketService.addListener(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL)
    .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          this.drivers[this.driverIndex].googleETA = data.message;
        } else {
          this.drivers[this.driverIndex].googleETA = null;
        }
      });

    this.socketService.addListener(Events.UPDATE_ASSIGN_TRIP)
    .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data.success) {
          // sweetAlert('Success', data.message, 'success', 'OK');
          if (data.assign) {
            this.trip.isReadyForPickup = data.assign.isReadyForPickup;
            this.trip.isVipTrip = data.assign.isVipTrip;
            this.trip.isConfirmedTrip = data.assign.isConfirmedTrip;
            this.trip.isVoiceMail = data.assign.isVoiceMail;
            this.trip.isMultiLoad = data.assign.isMultiLoad;
          }
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });
  }

  getNearbyDriver() {
    let data: any = {}
      data = {
        jobOriginLatitude: this.trip.jobOriginLatitude,
        jobOriginLongitude: this.trip.jobOriginLongitude,
        fundingSource: this.trip.cooperate,
        spaceType: this.trip.spaceType,
        scheduleTime: this.trip.scheduleTime,
        isNearBy: true,
        loadTime: this.preSpaceTypes[this.trip.spaceType].loadTime,
        unloadTime: this.preSpaceTypes[this.trip.spaceType].unloadTime,
        milage: this.trip.milage,
        jobDestinationLatitude: this.trip.jobDestinationLatitude,
        jobDestinationLongitude: this.trip.jobDestinationLongitude,
        appointmentTime: this.trip.appointmentTime,
      };

      if (this.trip.serviceArea) {
        data.serviceArea = this.trip.serviceArea
      }



    this.driverService
      .getNearbyDrivers(data)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data && data.drivers) {
          this.drivers = data.drivers;
          // this.nearbyDrivers.sort( function( a, b ) { return a.priority - b.priority; } )
          const selectedDriver = this.drivers.find(driver => driver._id === this.trip.driver)
          this.onSelectDriver(selectedDriver);


        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }


  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.drivers = data;
            if (this.driverId) {
              const selectedDriver = this.drivers.find(driver => driver._id === this.driverId)
              this.onSelectDriver(selectedDriver);
            }

          }
        },
      );
  }



  getMiles(driverIndex, driver) {
    this.driverIndex = -1;

    if (this.trip.jobOriginLatitude && this.trip.jobOriginLongitude && this.trip.jobDestinationLatitude && this.trip.jobDestinationLongitude) {
      const payload = {
        origin: this.trip.jobOriginLatitude + ' , ' + this.trip.jobOriginLongitude,
        destination: driver.coords[1] + ' , ' + driver.coords[0]
        // destination: vm.assign.jobDestinationLatitude + ' , ' + vm.assign.jobDestinationLongitude
      };
      payload['dbMiles'] = driver.miles || 0;
      payload['isLog'] = true;
      this.driverIndex = driverIndex;
      this.socketService.emit(Events.GET_DRIVER_MILES_FOR_ASSIGN_MODAL, payload);
    } else {
      sweetAlert('Alert', 'Please Select Pickup and DropOff Address', 'warning', 'OK');
    }
  }

  onUpdateTrip(event) {
    this.onUpdate.emit(event);
  }

  onCreateTrip(event) {
    this.onCreate.emit(event);
  }

  saveTrip() {
    if(this.selectedDriver){

    if (this.selectedDriver.hasCheckout) {
      sweetAlert('Warning', `${this.selectedDriver.displayName}'s shift has already ended.`, 'warning', 'OK');
      return;
    }

    let isOvertimeViolation = false;
    if (this.user.isManagerAuthorization && !['Restricted (RM,SM,ASM)', 'Dispatcher Manager', 'Full Access'].includes(this.userRole)) {
      isOvertimeViolation = hasOvertimeViolation(this.trip, this.selectedDriver.shift, moment(this.trip.scheduleTime).tz(this.timeZone).toISOString() , this.timeZone);
    }

    if (isOvertimeViolation) {
      sweetAlertWithInput(
        "Alert",
        `${this.selectedDriver.displayName} has exceeded the allowed working hours. Are you sure you want to assign this trip?`,
        "warning",
        "Yes, Assign",
        "No",
        true,
        "Min. 10 characters.",
        isOvertimeViolation,
        this.user
      ).then((result: any) => {
        if (result.value) {
          this.tripComponent.newTripForm.patchValue({
            overTimeReason: result.value.note,
            driver: this.selectedDriver,
            status: 'offered',
            jobStatus: 'offered',
          })
          this.tripComponent.onCreateTrip();
        }
      });
    }
    else {
      this.tripComponent.newTripForm.patchValue({
        driver: this.selectedDriver,
        status: 'offered',
        jobStatus: 'offered',
      });
      this.tripComponent.onCreateTrip();
    }
    }
     else {
      this.tripComponent.onCreateTrip();
    }



  }

    isTripAfterDriverShift(): boolean {
    if (!this.selectedDriver || !this.selectedDriver.shift ||!this.selectedDriver.shift.checkout || !this.trip || !this.trip.scheduleTime) {
      return false;
    }

    const tripTime = moment(this.trip.scheduleTime).tz(this.timeZone);
    const tripDate = tripTime.format('YYYY-MM-DD');
    const shiftEndTime = moment.tz(`${tripDate} ${this.selectedDriver.shift.checkout}`, 'YYYY-MM-DD HH:mm', this.timeZone);
    const twoHoursAfterShiftEnd = shiftEndTime.clone().add(2, 'hours');

    return tripTime.isAfter(twoHoursAfterShiftEnd);
  }

  cancelTrip() {
     this.isShowCancel = true;
  }

  unAssign() {
    this.trip.status = 'unassigned';
    this.trip.jobStatus = 'pending';
    this.trip.priority = 0;
    this.trip.assignThrough = 'panel';
    this.updateTrip(this.trip);
  }

  archive() {
    this.trip.status = 'archived';
    this.updateTrip(this.trip);
  }

  updateTrip(payload) {
    this.assignTripService
      .updateTrip(payload)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.onUpdate.emit(data);
        }
      });
  }

  updateJob() {
    let params = {
      assignId: this.trip._id,
      priority : 0,
      assignThrough : 'panel'
    }
    params['isReadyForPickup'] = !this.trip['isReadyForPickup'];
    this.socketService.emit(Events.UPDATE_ASSIGN_TRIP, params);
  }

  onSelectDriver(driver) {
    if(!driver) return;
    this.selectedDriver = driver;
    if(driver.coords && driver.coords.length){
      this.driverLoc = {
        lat: driver.coords[1],
        lng: driver.coords[0]
      };
      this.updateBounds();
    }

  }

  closeModal() {
    this.onCloseModal.emit();
  }

  closeCancelModal(event) {
    this.isShowCancel = false;
    this.onUpdate.emit(event);
  }

  ngOnDestroy(): void {
  }
}
